// extracted by mini-css-extract-plugin
export default {"wrapper":"C_PaySystems_wrapper__tmd2O"};